import { render, staticRenderFns } from "./signaturePad.vue?vue&type=template&id=b3a174b6&scoped=true"
import script from "./signaturePad.vue?vue&type=script&lang=js"
export * from "./signaturePad.vue?vue&type=script&lang=js"
import style0 from "./signaturePad.vue?vue&type=style&index=0&id=b3a174b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.23_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_t2asupwbbn4g4z6gf7kzzdxifm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a174b6",
  null
  
)

export default component.exports